import React from "react";
import "../styles/styles.css";
import "../styles/customstyle.css";
import NavbarStandard from "../components/NavbarStandard";
import FooterStandard from "../components/FooterStandard";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ServicePage = () => {
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <meta
            name="keywords"
            content="UMKM, Payment, kasir, invoice, Merchant, toko, digital, pembayaran, QRIS"
          />
          <title>Ojire Anywhere | Pengaduan Keluhan</title>
        </Helmet>
        <div id="page-top">
          {/* Navigation */}
          <NavbarStandard />

          <section className="page-section" id="prosesPengaduan">
            <div className="container">
              <h1 className="mb-3">Proses Pengaduan</h1>
              <p className="text-justify">
                Di Ojire, kami berkomitmen untuk memberikan layanan terbaik
                kepada kamu setiap saat. Dalam situasi kamu tidak puas atas
                layanan kami, dan atau ada yang kurang jelas silakan hubungi
                kami sesegera mungkin.
              </p>

              <h4 className="mt-4">Layanan Pengaduan Konsumen:</h4>
              <p className="my-2">
                PT. Ojire Teknologi Informasi | ojire.technology | Aplikasi
                Ojire Anywhere | +62 21 2188 0008 (Senin - Jumat 08.00 - 17.00
                WIB) | halo@ojire.com
              </p>
              <p className="mb-1 fw-semibold">
                Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga
                Kementerian Perdagangan Republik Indonesia
              </p>
              <p className="mb-0">
                <img src="/img/WhatsApp.svg" width="20px" alt="whatsapp icon" />
                <a
                  href="https://wa.me/+6285311111010"
                  className="text-reset"
                  target="_blank"
                >
                  Ditjen PKTN: +62853 1111 1010
                </a>
              </p>

              <h4 className="mt-4">
                Bagaimana <i>Help Center</i> Ojire akan membantu kamu:
              </h4>
              <ol className="mt-2">
                <li>
                  <strong>Penyelesaian Secara Cepat</strong>
                  <p className="text-justify">
                    Kami akan berusaha menyelesaikan pengaduan kamu secepat
                    mungkin sesuai dengan SLA kami.
                  </p>
                </li>
                <li>
                  <strong>Konfirmasi</strong>
                  <p className="text-justify">
                    Jika pengaduan kamu tidak dapat terselesaikan secara instan,
                    kami akan mengirimkan konfirmasi tertulis <b>via email</b>{" "}
                    dalam waktu 3 hari kerja setelah hari pengaduan kamu kami
                    terima. Dan kami akan memberitahukan kapan kami akan dapat
                    menyelesaikannya.
                  </p>
                </li>
                <li>
                  <strong>Pembaharuan Perkembangan</strong>
                  <p className="text-justify">
                    Dalam kebanyakan kasus, pengaduan kamu akan diselesaikan
                    dalam waktu 15 hari kerja. Jika kami tidak dapat
                    menyelesaikan pengaduanmu dalam jangka waktu tersebut, kamu
                    akan menerima email yang menjelaskan alasannya dan kapan
                    kamu akan mendapatkan penyelesaiannya (tidak lebih dari 35
                    hari kerja setelah hari kami pertama kali menerima pengaduan
                    kamu).
                  </p>
                </li>
                <li>
                  <strong>Tanggapan Akhir</strong>
                  <p className="text-justify">
                    Ketika pengaduan kamu telah diselesaikan, kamu akan menerima
                    tanggapan akhir dari Ojire.
                  </p>
                </li>
                <li>
                  <strong>Jika Kamu Tetap Tidak Puas</strong>
                  <p className="text-justify">
                    Tujuan kami adalah menyelesaikan semua pengaduan secara
                    netral dan cepat. Namun, jika kamu tidak puas dengan
                    resolusi yang kami berikan, atau jika 35 hari kerja telah
                    berlalu sejak kamu pertama kali mengajukan pengaduan, kamu
                    memiliki hak untuk merujuk pengaduan kamu ke Direktorat
                    Jenderal Perlindungan Konsumen dan Tertib Niaga Kementerian
                    Perdagangan Republik Indonesia.
                  </p>
                </li>
              </ol>
            </div>
          </section>

          {/* Footer */}
          <FooterStandard />
          {/* Footer*/}
        </div>
      </div>
    </HelmetProvider>
  );
};

export default ServicePage;
